import React from "react";
import "./HostWorkshop.css";
import image_1 from "../images/HostWorkshop_Image1.png";
import image_2 from "../images/HostWorkshop_Image2.png";

function HostWorkshop() {
  return (
    <section className="host-workshop-container">
      <h2 className="workshop-title">Host a Culinary Workshop</h2>

      <p className="workshop-description">
        Every single one of our workshops is inspired by a traditional recipe 
        connected to a region or culture from somewhere around the globe.
      </p>

      <div className="workshop-content-row">
        <div className="workshop-image-section">
          <div className="image-wrapper">
            <img
              src={image_1}
              alt="Kids preparing a pizza with ingredients"
              className="workshop-image"
            />
            <div className="workshop-caption">
              Pizza Margherita – Naples, Italy 🇮🇹
            </div>
          </div>
        </div>

        <div className="workshop-quote-section">
          <div className="quote-wrapper">
            <div className="yellow-circle"></div>
            <img
              src={image_2}
              alt="Quote about cultural learning"
              className="workshop-quote-image"
            />
          </div>
        </div>
      </div>

      {/* In-person and virtual call-to-action section */}
      <div className="section">
        <div className="category in-person">
          <div className="left">
            <div className="tag">IN-PERSON</div>
            <h2>For Parents & Organizations</h2>
          </div>
          <div className="right">
            <p>
              If you are a parent and/or academic organization leader and would like to bring <strong>our</strong> educational programming to <strong>your</strong> community, please complete the form below.
            </p>
            <a className="cta" href="https://z6x78xg9ssx.typeform.com/to/tAgw4Hwy" target="_blank" rel="noopener noreferrer">
              Host a workshop →
            </a>
          </div>
        </div>

        <div className="category virtual">
          <div className="left">
            <div className="tag">VIRTUAL</div>
            <h2>For Chefs & Influencers</h2>
          </div>
          <div className="right">
            <p>
              If you are a professional chef or culinary influencer, we encourage you to help our cause. Check out the link below to learn more.
            </p>
            <a
              className="cta"
              href="https://www.gofundme.com/f/cultured-kids-cuisine-funding-amp-donations"
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate →
            </a>
            <p>
              If you would like to host a virtual workshop for our community of eager learners by bridging <strong>your</strong> culinary expertise with <strong>our</strong> culturally-driven curricula to impact hundreds of youth worldwide, please complete the form below.
            </p>
            <a className="cta" href="https://z6x78xg9ssx.typeform.com/to/tAgw4Hwy" target="_blank" rel="noopener noreferrer">
              Host a virtual workshop →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HostWorkshop;







